<template>
  <div class="flex flex-col min-h-dvh bg-blue-50">
    <div class="flex-grow">
      <the-header />

      <div class="pt-6">
        <slot />
      </div>
    </div>

    <slot name="footer"></slot>

    <teleport to="#floats">
      <the-contact v-if="!contact_hidden" />
    </teleport>
  </div>
</template>

<script setup>
import TheHeader from '~/components/layouts/TheHeader.vue';
import TheContact from '~/components/layouts/TheContact.vue';
import { useRoute } from 'vue-router';
import ImageLogo from '~/assets/images/core/logo.svg';

const route = useRoute();

useHead({
  titleTemplate: page_title => {
    if (page_title?.includes('undefined')) {
      page_title = '';
    }

    return page_title ? page_title + ' | %siteName' : '%siteName';
  },
  templateParams: {
    siteName: 'تامینیفای',
  },
  link: [
    {
      rel: 'canonical',
      href: import.meta.env.VITE_SITE_URL + route.fullPath,
    },
  ],
  meta: [
    {
      name: 'keywords',
      content: [
        '%siteName',
        'خرید عمده, به قیمت تولیدی, حاشیه سود بالا, تولیدکنندگان معتبر, تولیدی معتبر, پوشاک',
      ].join(', '),
    },
    {
      property: 'og:title',
      content: '%s | %siteName',
    },
    {
      property: 'og:locale',
      content: 'fa_IR',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:url',
      content: import.meta.env.VITE_SITE_URL + route.fullPath,
    },
    {
      property: 'og:site_name',
      content: 'taminify.com',
    },
    {
      property: 'og:image',
      content: ImageLogo,
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'twitter:site',
      content: 'taminify.com',
    },
    {
      name: 'twitter:title',
      content: '%s | %siteName',
    },
    {
      name: 'twitter:image',
      content: ImageLogo,
    },
  ],
});

const contact_hidden = computed(() => route.meta.contact_hidden);
</script>
